import { useEffect, useState, useRef } from 'react';
import { useRefinementList, useMenu, useClearRefinements, useCurrentRefinements, useInstantSearch } from 'react-instantsearch-hooks-web';
import styles from './RefinementAccordion.module.scss'

import ChevronDown from '/packages/icons/chevron-down.svg';
import ChevronUp from '/packages/icons/chevron-up.svg';
import Xmark from '/packages/icons/xmark.svg';

import useMediaQuery from '../../hooks/useMediaQuery';
import Button from '../../components/Button';
import dynamic from 'next/dynamic';
const CustomRefinementList = dynamic(() => import('../../components/refinement-list'), { ssr: false });
const RangeSlider = dynamic(() => import('../../components/range-slider'), { ssr: false });

export default function Refinement(props) {
  const { menu, range, search, setOpenBackdrop, title, attribute } = props
  const { items } = useMenuOrRefinementList(props, menu);
  const [openModal, setOpenModal] = useState(false)
  const [hasRefinements, setHasRefinements] = useState(false)
  const [showStats, setShowStats] = useState(false)

  const isBreakPoint = useMediaQuery(768)

  function useMenuOrRefinementList(props, menu) {
    const hook = menu ? useMenu : useRefinementList;
    return hook(props);
  }

  // show stats on load
  useEffect(() => {
    setShowStats(true)
  }, [])

  // backdrop
  useEffect(() => {
    if (openModal && setOpenBackdrop) {
      setOpenBackdrop(true)
    } else if (setOpenBackdrop) {
      setOpenBackdrop(false)
    } else return
  }, [openModal])

  //close on click outside
  let modalRef = useRef()
  useEffect(() => {

    let handler = (e) => {
      if (!modalRef.current?.contains(e.target)) {
        setOpenModal(false);
      }
    }
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler)
    }

  }, [isBreakPoint]);

  if (items.length === 0) {
    return null
  }

  else
    return (
      <>
        <div className={styles.refinement} ref={modalRef}>

          <button
            className={`${styles.button} ${hasRefinements ? styles.hasRefinements : undefined} ${openModal ? styles.active : undefined}`}
            onClick={() => setOpenModal(!openModal)}
          >
            {title}

            <CurrentRefinementsCount
              {...props}
              includedAttributes={[attribute]}
              setHasRefinements={setHasRefinements}
              hasRefinements={hasRefinements}
            />

            {openModal ?
              <ChevronUp />
              :
              <ChevronDown />
            }
          </button>

          <div className={`${styles.modal} ${openModal ? styles.activeModal : undefined}`}>

            <div className={styles.body} onClick={() => menu && setOpenModal(false)}>
              {range ? <RangeSlider {...props} /> : <CustomRefinementList {...props} />}
            </div>

            <div className={styles.footer}>
              <ClearRefinements includedAttributes={[attribute]} setOpenModal={setOpenModal} />
              <Button type="button" className="primary" onClick={() => setOpenModal(false)}>{showStats && <Stats openModal={openModal} showStats={showStats} />}</Button>
            </div>

          </div>

        </div>

      </>
    )
}


function Stats() {
  const { results } = useInstantSearch();
  return (
    <div className={styles.productCount}>
      {results.nbHits === 0 ? "No Products" : `Show ${results.nbHits} ${results.nbHits > 1 ? "products" : "product"}`}
    </div>
  )
}


function ClearRefinements(props) {
  const { refine } = useClearRefinements(props);
  const handleClick = () => {
    refine()
    props.setOpenModal(false)
  }
  return (
    <Button type="button" className="danger" onClick={() => handleClick()}>
      <Xmark /> Clear</Button>
  )
}

function CurrentRefinementsCount(props) {
  const { items } = useCurrentRefinements(props);
  const { title } = props;
  const setHasRefinements = props.setHasRefinements;

  // Count the total number of refinements
  const total = items.reduce((count, item) => {
 if (title === 'subcategory') {
      return count + item.refinements.filter(refinement => refinement.label.includes(':')).length;
    }
    else {
      return count + item.refinements.length;
    }
  }, 0);

  useEffect(() => {
    setHasRefinements(total >= 1);
  }, [total]);

  return (
    <>
      {total >= 1 && <> ({total})</>}
    </>
  );
}